import type { AudioLanguage } from "@/utils/types";

export type ElevenLabsLanguage =
  | "ar"
  | "bg"
  | "zh"
  | "hr"
  | "cs"
  | "da"
  | "nl"
  | "en"
  | "fi"
  | "fr"
  | "de"
  | "el"
  | "hi"
  | "hu"
  | "id"
  | "it"
  | "ja"
  | "ko"
  | "ms"
  | "no"
  | "pl"
  | "pt"
  | "ro"
  | "ru"
  | "sk"
  | "es"
  | "sv"
  | "ta"
  | "tl"
  | "tr"
  | "uk"
  | "vi";

export type ElevenLabsAccent =
  | "standard"
  | "cantonese"
  | "european"
  | "brazilian"
  | null;

export const AUDIO_LANGUAGE_TO_ELEVEN_LABS_LANGUAGE: Record<
  AudioLanguage,
  ElevenLabsLanguage | null
> = {
  // Directly supported languages
  en: "en",
  "en-medical": "en",
  fr: "fr",
  "fr-CA": "fr",
  de: "de",
  "de-CH": "de",
  it: "it",
  pt: "pt",
  "pt-BR": "pt",
  es: "es",
  zh: "zh",
  "zh-TW": "zh",
  "zh-HK": "zh",
  ar: "ar",
  bg: "bg",
  hr: "hr",
  cs: "cs",
  da: "da",
  nl: "nl",
  "nl-BE": "nl",
  fi: "fi",
  el: "el",
  hi: "hi",
  hu: "hu",
  id: "id",
  ja: "ja",
  ko: "ko",
  ms: "ms",
  no: "no",
  pl: "pl",
  ro: "ro",
  ru: "ru",
  sk: "sk",
  sv: "sv",
  tl: "tl",
  ta: "ta",
  tr: "tr",
  uk: "uk",
  vi: "vi",

  // Not supported by ElevenLabs
  bn: null,
  ka: null,
  gu: null,
  he: null,
  mr: null,
  te: null,
  th: null,
  ur: null,
  bs: null,
  sr: null,
  gl: null,
  mk: null,
  be: null,
  af: null,
  sq: null,
  am: null,
  hy: null,
  as: null,
  az: null,
  ba: null,
  eu: null,
  br: null,
  ca: null,
  et: null,
  fo: null,
  ht: null,
  ha: null,
  haw: null,
  is: null,
  jw: null,
  kk: null,
  km: null,
  la: null,
  lv: null,
  ln: null,
  lt: null,
  lb: null,
  mg: null,
  mt: null,
  mi: null,
  mn: null,
  ne: null,
  oc: null,
  ps: null,
  fa: null,
  sa: null,
  sn: null,
  sd: null,
  si: null,
  sl: null,
  so: null,
  su: null,
  sw: null,
  tg: null,
  tt: null,
  tk: null,
  uz: null,
  cy: null,
  yi: null,
  yo: null,
  my: null,
  kn: null,
  lo: null,
  ml: null,
  nn: null,
  pa: null,
  bo: null,
  ast: null,
  ceb: null,
  ff: null,
  ga: null,
  ig: null,
  kea: null,
  ku: null,
  ky: null,
  lg: null,
  luo: null,
  nso: null,
  ny: null,
  or: null,
  umb: null,
  wo: null,
  xh: null,
  zu: null,
};

export const AUDIO_LANGUAGE_TO_ELEVEN_LABS_ACCENT: Record<
  AudioLanguage,
  ElevenLabsAccent | null
> = {
  pt: "european",
  "pt-BR": "brazilian",
  zh: "standard",
  "zh-TW": "standard",
  "zh-HK": "cantonese",

  // No accents supported
  en: null,
  "en-medical": null,
  fr: null,
  "fr-CA": null,
  de: null,
  "de-CH": null,
  it: null,
  es: null,
  ar: null,
  bg: null,
  hr: null,
  cs: null,
  da: null,
  nl: null,
  "nl-BE": null,
  fi: null,
  el: null,
  hi: null,
  hu: null,
  id: null,
  ja: null,
  ko: null,
  ms: null,
  no: null,
  pl: null,
  ro: null,
  ru: null,
  sk: null,
  sv: null,
  tl: null,
  ta: null,
  tr: null,
  uk: null,
  vi: null,

  // Not supported by ElevenLabs
  bn: null,
  ka: null,
  gu: null,
  he: null,
  mr: null,
  te: null,
  th: null,
  ur: null,
  bs: null,
  sr: null,
  gl: null,
  mk: null,
  be: null,
  af: null,
  sq: null,
  am: null,
  hy: null,
  as: null,
  az: null,
  ba: null,
  eu: null,
  br: null,
  ca: null,
  et: null,
  fo: null,
  ht: null,
  ha: null,
  haw: null,
  is: null,
  jw: null,
  kk: null,
  km: null,
  la: null,
  lv: null,
  ln: null,
  lt: null,
  lb: null,
  mg: null,
  mt: null,
  mi: null,
  mn: null,
  ne: null,
  oc: null,
  ps: null,
  fa: null,
  sa: null,
  sn: null,
  sd: null,
  si: null,
  sl: null,
  so: null,
  su: null,
  sw: null,
  tg: null,
  tt: null,
  tk: null,
  uz: null,
  cy: null,
  yi: null,
  yo: null,
  my: null,
  kn: null,
  lo: null,
  ml: null,
  nn: null,
  pa: null,
  bo: null,
  ast: null,
  ceb: null,
  ff: null,
  ga: null,
  ig: null,
  kea: null,
  ku: null,
  ky: null,
  lg: null,
  luo: null,
  nso: null,
  ny: null,
  or: null,
  umb: null,
  wo: null,
  xh: null,
  zu: null,
};
